import { Form, Input } from "semantic-ui-react";
import { SharedAddressFieldProps } from "./AddressFormField";
import classNames from "classnames";
import { useId } from "react-aria";

interface CityFormFieldProps extends SharedAddressFieldProps {
  subLabelPadding?: boolean;
}

export function CityFormField({
  disabled,
  labelClassName,
  label = "City",
  subLabel,
  subLabelPadding,
  error,
  required,
  transform,
  handleChange,
  value,
  isMobileLayout,
}: CityFormFieldProps) {
  const id = useId();
  return (
    <Form.Field
      className={classNames("tw-w-auto tw-text-nowrap", {
        "tw-mb-4": isMobileLayout,
      })}
      required={required}
      disabled={disabled}
      error={!!error}
    >
      <label htmlFor={id} className={labelClassName}>
        {label}
      </label>
      {(subLabel || subLabelPadding) && (
        <div
          className={classNames("sub-label", {
            "tw-text-[#b2b2b2]": disabled,
          })}
        >
          {subLabel}
        </div>
      )}
      <Input
        id={id}
        type='text'
        value={transform.input(value)?.city ?? ""}
        onChange={(_, { value }) => handleChange({ city: value })}
        disabled={disabled}
        autoComplete='address-level2'
      />
    </Form.Field>
  );
}
